import { mxRectangle as MxRectangle } from 'mxgraph-js';
import HCLVertexState from '../../HCLCellState/HCLVertexState';
import HCLText from '../HCLText';
/**
 * Badge to show on mxCell
 */
class Badge extends HCLText {
  static PREFERRED_WIDTH = 35;

  constructor() {
    super();
    this.color = 'black';
    this.background = 'rgba(255,172,73,0.8)';
    this.border = 'rgba(255,95,74,0.8)';
  }

  getBounds(state: HCLVertexState): MxRectangle {
    const scale = state.getCell().getGraph().getView().getScale();
    return new MxRectangle(state.x + state.width - 8 * scale, state.y + 8 * scale, Badge.PREFERRED_WIDTH, 0);
  }

  getValue(state: HCLVertexState): string {
    return state.getCell().getKey();
  }
}

export default Badge;
